import { Home, BookOpen, Play, Users, User, Sparkles, type LucideIcon } from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  Icon: LucideIcon;
  isPremiumGated?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Home', Icon: Home },
  { to: '/library', label: 'Library', Icon: BookOpen },
  { to: '/affirmations', label: 'Affirmations', Icon: Sparkles, isPremiumGated: true },
  { to: '/practice', label: 'Practice', Icon: Play },
  { to: '/community', label: 'Community', Icon: Users },
  { to: '/profile', label: 'Profile', Icon: User },
];
